import { render, staticRenderFns } from "./BundleProduct.vue?vue&type=template&id=60245a44&"
import script from "./BundleProduct.vue?vue&type=script&lang=js&"
export * from "./BundleProduct.vue?vue&type=script&lang=js&"
import style0 from "./BundleProduct.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VariantSelector: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/VariantSelector.vue').default})
